export type GenesysCloudCobrowseState = { [id: string]: boolean };
export type GenesysCloudCobrowseAllowedState = { [id: string]: boolean };

export const initialState = (): GenesysCloudCobrowseState => ({});
export const initialAllowedState = (): GenesysCloudCobrowseAllowedState => ({});
